/**
 * Represent the newsletter captcha module
 *
 */
function recaptchaOnLoad(){
  $('form.need-recaptcha').each(function(){
    renderCaptcha($(this));
  });
}

function renderCaptcha($form){
  $form.attr("captcha",grecaptcha.render($form.find('.div-recaptcha')[0],
    {
      'sitekey': publicReCaptchaKey,
      execution: 'execute',
      appearance: 'execute',
      language: currentlangugeIsoCode,
      'callback' : function(token){
        switch($form.data('captcha-id')) {
          case "newsLetterSubscriptionFormOptinSF":
            callSubmitNewsLetterSubscriptionFormOptinSF(token);
            break;
          case "FormNewsLetterPopup":
            callSubmitNewsLetterSubscriptionPopup(token);
            break;
          case "guestCheckoutMailForm":
            callValidateEmailGuestCheckout(token);
            break;
          case "deliveryEmptyForm":
            callAddEmptyAddress(token);
            break;
          case "addOrUpdateForm":
            callAddOrUpdateAddress(token);
            break;
          default:
          // code block
        }
      }
    }));
}

function submitWithRecaptcha(form){
  var widgetId = $(form).attr('captcha');
  grecaptcha.execute(widgetId);
}

function resetRecaptcha(form){
  var widgetId = $(form).attr('captcha');
  grecaptcha.reset(widgetId);
}

function callSubmitNewsLetterSubscriptionFormOptinSF(token){
  var $form = $('#newsLetterSubscriptionFormOptinSF');
  $form.find('input[name="g-recaptcha-response"]').attr("name","recaptcha");
  $form.submit();
}

function callSubmitNewsLetterSubscriptionPopup(token){
  return new Promise(function(resolve, reject) {
    submitNewsLetterPopupForm(document.querySelector('#FormNewsLetterPopup'));
    resolve();
    resetRecaptcha(document.querySelector('#FormNewsLetterPopup'));
  });
}

function callValidateEmailGuestCheckout(token) {
  return new Promise(function(resolve, reject) {
    validateEmailGuestCheckout('#guestCheckoutMailForm');
    resolve();
    resetRecaptcha(document.querySelector('#guestCheckoutMailForm'));
  });
}

function callAddEmptyAddress(token) {
  return new Promise(function(resolve, reject) {
    dispatchCustomEvent('addEmptyAddress')
    resolve();
    resetRecaptcha(document.querySelector('#deliveryAddAddessForm'));
  });
}

function callAddOrUpdateAddress(token) {
  return new Promise(function(resolve, reject) {
    dispatchCustomEvent('addOrUpdateAddress')
    resolve();
    resetRecaptcha(document.querySelector('.create_update_address_form'));
  });
}

function dispatchCustomEvent(eventId,eventDetail){
  document.dispatchEvent(new CustomEvent(eventId,{'detail' : eventDetail}));
}
